export const accommodationFormatter = (values) => ({
  hotel: values.hospedyHotelName || values.hotel,
  reservationConfirmed: Boolean(values.hospedyConfirmation),
  reservationNumber:
    values.hospedyReservationNumber || values.reservationNumber,
  type: values.hospedyType,
  subtype: values.subtype,
  naturalPersonGuarantee: values.endorsementUuid,
});
